import styled from 'styled-components';

const StyledServiceRow = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 1.5rem;
  margin: 2rem 0;
  position: relative;
`;

const StyledServiceRowIcon = styled.div`
  grid-column: span 1;
  display: grid;
  place-items: center;
  position: relative;
`;
const StyledServiceRowInfo = styled.div`
  grid-column: span 6;
`;

const StyledTransferTypeText = styled.p`
  color: ${(props) => props.theme.color.primary};
  margin: 0;
  font-size: 14px;
`;
const StyledRouteText = styled.p`
  font-weight: 700;
  font-size: 16px;
  margin: 0.25rem 0;
`;
const StyledTimesText = styled.p`
  font-size: 12px;
  margin: 0;
`;
const StyledLine = styled.div`
  position: absolute;
  width: 2px;
  background-color: ${(props) => props.theme.color.bodyTextColor};
  height: 70%;
  bottom: -25%;
  left: 50%;
  transform: translate(-50%, 50%);
  border-radius: ${(props) => props.theme.radius.sm};
`;

export {
  StyledServiceRow,
  StyledServiceRowIcon,
  StyledServiceRowInfo,
  StyledTransferTypeText,
  StyledRouteText,
  StyledTimesText,
  StyledLine,
};
